import { ensureDefined } from '@e-socna/utils';

import type { PersonMutationResult } from '../types/person-mutation-result.type';

export const getPersonIdInResult = (result: PersonMutationResult) =>
  ensureDefined({
    personId:
      'createPerson' in result
        ? result.createPerson._id
        : result.findOneAndUpdatePerson._id,
  }).personId;
